import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Overlay from 'componentsV2/Hero/components/Overlay';
import HeroBackground from 'componentsV2/Hero/components/HeroBackground';
import Kicker from 'componentsV2/Hero/components/Kicker';
import Badge from 'componentsV2/Badge';
import Description from 'componentsV2/Description';
import Headline from 'componentsV2/Headline';
import MobileInfo from 'componentsV2/Hero/components/MobileInfo';
import Logo from 'componentsV2/Logo';
import Metadata from 'componentsV2/Metadata';
import ProgressBar from 'componentsV2/ProgressBar';
import { saveLiveRestart as saveGlobalLiveRestart } from 'components/VideoPlayerGlobal/Actions';
import { saveLiveVideo as saveLiveVideoAction } from 'screens/Live/LiveActions';
import { setRecommendationIdAction } from 'index/AppActions';
import useBreakpoint from 'hooks/useBreakpoint';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';
import { ChannelProcessor } from '../../processors';
import style from './ChannelView.module.scss';
import ActionButtons from '../../../ActionButtons';

const Channel = ({
  analytics,
  bookmarks,
  callCollectionImpressionEvent,
  isOffset,
  item,
  saveLiveRestart,
  saveLiveVideo,
  setRecommendationId,
}) => {
  const {
    alternativeHeadline,
    backgroundProps,
    badgeProps,
    buttonArray,
    description,
    logoProps,
    metaData,
    mobileInfoProps,
    progressProps,
    title,
  } = ChannelProcessor({
    panel: item,
    bookmarks,
    analytics,
    callCollectionImpressionEvent,
    additionalFunctions: {
      saveLiveRestart,
      saveLiveVideo,
      setRecommendationId,
    },
  });
  const isMobile = isMobileBreakpoint(useBreakpoint());

  return (
    <HeroBackground item={item} theme={style} {...backgroundProps}>
      <Overlay theme={style} isOffset={isOffset}>
        <Badge theme={style} {...badgeProps} />
        <Logo theme={style} {...logoProps} />
        <Kicker theme={style} alternativeHeadline={alternativeHeadline} />
        {!isMobile && <Headline theme={style} text={title} />}
        <Description theme={style} description={description} />
        <ProgressBar {...progressProps} theme={style} />
        <Metadata theme={style} text={metaData} />
        <ActionButtons buttons={buttonArray} theme={style} />
        <MobileInfo
          badgeProps={badgeProps}
          description={description}
          item={item}
          progressProps={progressProps}
          {...mobileInfoProps}
        />
      </Overlay>
    </HeroBackground>
  );
};

Channel.propTypes = {
  analytics: PropTypes.shape({}),
  bookmarks: PropTypes.shape({}),
  callCollectionImpressionEvent: PropTypes.func,
  isOffset: PropTypes.bool,
  item: PropTypes.shape({}),
  saveLiveRestart: PropTypes.func.isRequired,
  saveLiveVideo: PropTypes.func.isRequired,
  setRecommendationId: PropTypes.func.isRequired,
};

export default connect(() => ({}), {
  saveLiveRestart: saveGlobalLiveRestart,
  saveLiveVideo: saveLiveVideoAction,
  setRecommendationId: setRecommendationIdAction,
})(Channel);
